import { RequestStatusType } from '@Enums/requestStatusType.enum';
import { RecipientStatusType } from '@Enums/recipientStatusType.enum';

export interface DocumentSigningStatusDto {
    /** Request status; may be returned as this field or as `status` from the API. */
    documentSigningRequestStatusType?: RequestStatusType;
    /** Request status; alternative field name from the API. Use `getRequestStatus(dto)` to read either. */
    statusCode?: number;
    recipientStatusType: RecipientStatusType;
}

/** Returns the request status from either `documentSigningRequestStatusType` or `status`. */
export function getRequestStatus(dto: DocumentSigningStatusDto): RequestStatusType | undefined {
    return dto.documentSigningRequestStatusType ?? dto.statusCode;
}
